module.exports = __webpack_public_path__ + "img/m2_max.f9b42c8e.f9b42c8e.png";